// React
import React from "react";
import { Routes, Route } from "react-router-dom";

// Libraries
import { Image } from "semantic-ui-react";

// Redux
import { connect } from "react-redux";

// Components
import Screen from "@Components/Screen";

// Forms
import Login from "./Components/Login";
import Register from "./Components/Register";
import ForgotPassword from "./Components/ForgotPassword";
import ResetPassword from "./Components/ResetPassword";
import VerifyPin from "./Components/VerifyPin";

// Image
import fondoBanner2 from "./Assets/fondoBanner2.png";
import logo4 from "./Assets/logo4.png";

// Styles
import styles from "./styles.module.css";

const Authentication = () => {
	return (
		<Screen>
			<div className={styles.imageContainer}>
				<Image className={styles.image} src={fondoBanner2} />
			</div>
			<div className={styles.formContainer}>
				<div className={styles.form}>
					<div className={styles.headerLogo}>
						<Image src={logo4} size="medium" centered />
					</div>
					<Routes>
						<Route index element={<Login />} />
						<Route path="login/:companyName?/:token?" element={<Login />} />
						<Route path="register/:companyName?/:token?" element={<Register />} />
						<Route path="forgotPassword/:companyName?/:token?" element={<ForgotPassword />} />
						<Route path="verifyPin" element={<VerifyPin />} />
						<Route path="resetPassword/:token" element={<ResetPassword />} />
					</Routes>
				</div>
			</div>
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return { isLoggedIn: user.isLoggedIn, companyId: company.companyId };
}

export default connect(mapStateToProps)(Authentication);
